var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "fit-content" } }, [
    _c(
      "div",
      { staticStyle: { display: "flex" } },
      [
        _vm._l(_vm.upElementBlocksList, function(upElementBlocks, index) {
          return [
            upElementBlocks.length > 0
              ? _c(
                  "div",
                  {
                    key: index,
                    staticClass: "section form-column",
                    style: { width: upElementBlocks[0].width + "px" }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.disabled,
                          "label-width": "130px",
                          "label-position": "right"
                        }
                      },
                      [
                        _vm._l(upElementBlocks, function(item, subIndex) {
                          return [
                            _c(
                              "span",
                              {
                                key: subIndex,
                                staticClass: "title",
                                staticStyle: { width: "100%" }
                              },
                              [
                                _vm._v(" " + _vm._s(item.title) + " "),
                                item.name === "polAirPortInfo"
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: _vm.$t(
                                            "SeaExport.PolPortInfoPrompt"
                                          ),
                                          placement: "top-start"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-warning-outline"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                item.name === "podAirPortInfo" ||
                                item.name === "airSecondVesselInfo"
                                  ? _c(
                                      "span",
                                      {
                                        key: subIndex + "2",
                                        staticStyle: {
                                          "font-weight": "lighter"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("SeaExport.LocalTime")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._l(item.elementNames, function(elementName) {
                              return _vm._t(elementName)
                            })
                          ]
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }